import { reset } from 'redux-form';
import * as action from './actions/creators';
import * as api from './health-summary-api';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';
import * as auth from '../auth/auth-middleware';
import { auditRequest } from '../audit/audit-middleware';
import { mapVisits } from './health-summary-mapper';

const HEALTH_SUMMARY_VIEW_AUDIT_TYPE = 'ccdaviewauditevent';

const prepareHtmlForDiv = (data) => {
  // there shouldn't be scripts here.  But strip script tags just in case
  let healthSummaryHtml = data;
  healthSummaryHtml = healthSummaryHtml.replace('<script>', '').replace('</script>', '');

  // replace the html and body tags with a div with a specified class
  healthSummaryHtml = healthSummaryHtml.replace('<html>', '').replace('</html>', '');
  healthSummaryHtml = healthSummaryHtml.replace('<body>', '<div class="ccdaContent">')
    .replace('</body>', '</div>');

  // replace the styling information to specify that styles are all "within" the ccdaContent div only
  const styleRegex = /<style\b[^>]*>([\s\S]*?)<\/style\b[^>]*>/igm;
  const styleContentArray = styleRegex.exec(healthSummaryHtml);
  const styleContent = (styleContentArray && styleContentArray.length > 0) ?
    styleContentArray[0] :
    null; // 0 includes style tags
  let modifiedStyleContent = styleContent;
  if (modifiedStyleContent !== null) {
    const defRegex = /\S(.*){/igm;
    const styleDefinitions = modifiedStyleContent.match(defRegex);
    for (let i = 0; i < styleDefinitions.length; i += 1) {
      modifiedStyleContent = modifiedStyleContent.replace(styleDefinitions[i], '.ccdaContent '
        + styleDefinitions[i]);
    }
    // We don't want a style reference to the overall body at all.  It should be the ccdaContent class
    modifiedStyleContent = modifiedStyleContent.replace('.ccdaContent body {', '.ccdaContent {');
  }

  healthSummaryHtml = healthSummaryHtml.replace(styleContent, modifiedStyleContent);
  return healthSummaryHtml;
};

export const loadHealthSummaryHtml = (patientId, identifier, sourceSystemDisplayName) => (dispatch) =>
  api.getHealthSummaryHtml(patientId, identifier).then(
    (response) => {
      const healthSummaryHtml = prepareHtmlForDiv(response.data);
      dispatch(action.healthSummaryHtmlLoaded(healthSummaryHtml));
      dispatch(auditRequest(HEALTH_SUMMARY_VIEW_AUDIT_TYPE, patientId,
        {
          ccdaId: identifier.ccdaId,
          startDate: identifier.startDate,
          endDate: identifier.endDate,
          sourceSystemDisplayName,
        }));
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      if (error.status === 404) {
        dispatch(action.updateHealthSummaryIdentifier(null));
      } else {
        dispatch(MsgBarActions.showErrorMessage());
        dispatch(action.healthSummaryHtmlFailed(error.message));
      }
    }
  );

export const setDownloadPath = (patientId, identifier) => (dispatch) => {
  dispatch(auth.getNewAccessTokenFromForcedRefresh()).then(
    (accessToken) => {
      let path = null;
      if (identifier !== null && identifier !== undefined) {
        path = api.getHealthSummaryDownloadPath(patientId, identifier, accessToken);
      }
      dispatch(action.healthSummaryDownloadPathSet(path));
    }
  );
};

export const filterHealthSummary = (patientId, filter) => (dispatch) =>
  api.filterHealthSummary(patientId, filter).then(
    (response) => {
      if (response.data && response.data.length) {
        dispatch(action.healthSummaryListLoaded(response.data));
        if (response.data.length === 1) {
          const identifier = response.data[0];
          dispatch(action.updateHealthSummaryIdentifier(identifier));
        }
      } else {
        dispatch(action.healthSummaryListLoaded([]));
      }
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage());
      dispatch(action.healthSummaryListLoadFailed(error.message));
    }
  );

export const getMostRecentHealthSummaryIdentifier = (patientId, ifSystemId) => (dispatch) =>
  api.getMostRecentHealthSummaryIdentifier(patientId, ifSystemId).then(
    (response) => {
      const mostRecentHealthSummaryIdentifier = response.data;
      dispatch(action.mostRecentHealthSummaryIdentifierLoaded(mostRecentHealthSummaryIdentifier));
      return mostRecentHealthSummaryIdentifier;
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      if (error.status === 404) {
        dispatch(action.updateHealthSummaryIdentifier(null));
      } else {
        dispatch(MsgBarActions.showErrorMessage());
        dispatch(action.mostRecentHealthSummaryIdentifierFailed(error.message));
      }
    }
  );

export const sendHealthSummary = (params, languageCode) => (dispatch) =>
  api.sendHealthSummary(params, languageCode).then(
    () => {
      dispatch(MsgBarActions.showSuccessMessage('healthsummarysent'));
      dispatch(reset(params.formName));
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      if (!error.isSessionTimeout) {
        dispatch(MsgBarActions.showErrorMessage(
          params.transmitType === 'email' ?
            'healthsummarysendfailed' :
            'healthsummarysendsecurelyfailed'
        ));
      }
    }
  );

export const getMostRecentOfficeVisitsForPatient = (patientId, language) => (dispatch) =>
  api.getMostRecentOfficeVisitsForPatient(patientId).then(
    (response) => {
      const mostRecentOfficeVisits = mapVisits(response.data, language);
      dispatch(action.recentOfficeVisitsLoaded(mostRecentOfficeVisits));
      return mostRecentOfficeVisits;
    },
    () => {
      dispatch(MsgBarActions.showErrorMessage());
      dispatch(action.recentOfficeVisitsFailed());
    }
  );

